<template>
    <div>
        <div style="background:#fff;width:100%;height:100%;">
            <quill-editor
                    v-model="content"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @change="onEditorChange($event)"
                    :style="{ height: '700px',width: '100%' }"
                    class="junScrollBar"
            >
                <!-- 自定义toolar -->
                <div id="toolbar" slot="toolbar">
                    <!-- Add a bold button -->
                    <button class="ql-bold" title="加粗">Bold</button>
                    <button class="ql-italic" title="斜体">Italic</button>
                    <button class="ql-underline" title="下划线">underline</button>
                    <button class="ql-strike" title="删除线">strike</button>
                    <button class="ql-blockquote" title="引用"></button>
                    <button class="ql-code-block" title="代码"></button>
                    <button class="ql-header" value="1" title="标题1"></button>
                    <button class="ql-header" value="2" title="标题2"></button>
                    <!--Add list -->
                    <button class="ql-list" value="ordered" title="有序列表"></button>
                    <button class="ql-list" value="bullet" title="无序列表"></button>
                    <!-- Add font size dropdown -->
                    <select class="ql-header" title="段落格式">
                        <option selected>段落</option>
                        <option value="1">标题1</option>
                        <option value="2">标题2</option>
                        <option value="3">标题3</option>
                        <option value="4">标题4</option>
                        <option value="5">标题5</option>
                        <option value="6">标题6</option>
                    </select>
                    <select class="ql-size" title="字体大小">
                        <option value="10px">10px</option>
                        <option value="12px">12px</option>
                        <option value="14px">14px</option>
                        <option value="16px" selected>16px</option>
                        <option value="18px">18px</option>
                        <option value="20px">20px</option>
                    </select>
                    <select class="ql-font" title="字体">
                        <option value="SimSun">宋体</option>
                        <option value="SimHei">黑体</option>
                        <option value="Microsoft-YaHei">微软雅黑</option>
                        <option value="KaiTi">楷体</option>
                        <option value="FangSong">仿宋</option>
                        <option value="Arial">Arial</option>
                    </select>
                    <!-- Add subscript and superscript buttons -->
                    <select class="ql-color" value="color" title="字体颜色"></select>
                    <select class="ql-background" value="background" title="背景颜色"></select>
                    <select class="ql-align" value="align" title="对齐"></select>
                    <button class="ql-clean" title="还原"></button>
                    <button class="ql-link" title="超链接"></button>
                    <!-- You can also add your own -->
                    <button class="ql-image" title="图片"></button>
                    <!--<button class="ql-video" title="视频"></button>-->
                </div>
            </quill-editor>
            <el-upload
                    class="upload-demo"
                    :action="params.action"
                    :headers="params.headers"
                    :data="params.data"
                    :before-upload="beforeUpload"
                    :on-success="upScuccess"
                    ref="upload"
                    style="display:none"
            >
                <el-button size="small" type="primary" id="imgInput" element-loading-text="插入中,请稍候">点击上传</el-button>
            </el-upload>
        </div>
    </div>
</template>
<script>
    // 图片服务器地址
    import { Quill, quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    // 自定义字体大小
    let Size = Quill.import('attributors/style/size')
    Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
    Quill.register(Size, true)
    // 自定义字体类型
    var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif', '宋体', '黑体']
    var Font = Quill.import('formats/font')
    Font.whitelist = fonts
    Quill.register(Font, true)
    export default {
        name: 'eventRequire',
        props:{
            content_text:{type: String}
        },
        data () {
            return {
                content: this.content_text,
                str: '',
                editorOption: {
                    modules: {
                        toolbar: {
                            container: '#toolbar'
                        }
                    },
                    placeholder: "请在这里输入..."
                },
                addRange: [],
                uploadType: '', // 上传的文件类型（图片、视频
                params:{
                    action: this.$client.API_URL+'/adminapi/upload/images',
                    data:{path:'news'},
                    headers:{token:localStorage.getItem('token')}
                },
            }
        },
        computed: {
            editor () {
                return this.$refs.myQuillEditor.quill
            }
        },
        mounted () {
            this.editor.getModule('toolbar').addHandler('image', this.imgHandler)
//            this.editor.getModule('toolbar').addHandler('video', this.videoHandler)
            let content = '' // 请求后台返回的内容字符串
            this.str = this.escapeStringHTML(content)
            //console.log(this.str)
        },
        watch:{
            content_text:{
                handler(val, oldVal){
                    this.content = val;
                    this.$emit('update:content_text', val);
                }
            },
            content:{
                handler(val, oldVal){
                    this.$emit('update:content_text', val);
                }
            }
        },
        methods: {
            escapeStringHTML (str) {
                str = str.replace(/</g, '<')
                str = str.replace(/>/g, '>')
                return str
            },
            // 图片上传之前调取的函数
            // 这个钩子还支持 promise
            beforeUpload (file) {
                // return this.qnUpload(file)
            },
            // 点击图片ICON触发事件
            imgHandler (state) {
                this.addRange = this.editor.getSelection()
                if (state) {
                    let fileInput = document.getElementById('imgInput')
                    fileInput.click() // 加一个触发事件
                }
                this.uploadType = 'image'
            },
            onEditorChange ({ editor, html, text }) {
                this.content = html;
                //console.log(this.content)
                /*this.$refs.myQuillEditor.quill.enable(false);
                setTimeout(()=>{
                        this.$refs.myQuillEditor.quill.enable(true);
                },0)*/
            },
            // 点击视频ICON触发事件
           /* videoHandler (state) {
                this.addRange = this.editor.getSelection()
                if (state) {
                    let fileInput = document.getElementById('imgInput')
                    fileInput.click() // 加一个触发事件
                }
                this.uploadType = 'video'
            },*/
            upScuccess (res, file, fileList) {
                let vm = this;
                let url = this.$client.IMG_URL + res.data.file_url
                if (url != null && url.length > 0) {
                    let value = url
                    vm.addRange = this.editor.getSelection()
                    value = value.indexOf('http') !== -1 ? value : 'http:' + value
                    this.editor.insertEmbed(vm.addRange !== null ? vm.addRange.index : 0, vm.uploadType, value, Quill.sources.USER)
                } else {
                    this.$message.error(`${vm.uploadType}插入失败`)
                }
                this.$refs['upload'].clearFiles() // 插入成功后清除input的内容
            }
        },
        components: {
            quillEditor
        }
    }
</script>
<style>
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=SimSun]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=SimSun]::before {
        content: "宋体";
        font-family: "SimSun";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=SimHei]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=SimHei]::before {
        content: "黑体";
        font-family: "SimHei";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=Microsoft-YaHei]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=Microsoft-YaHei]::before {
        content: "微软雅黑";
        font-family: "Microsoft YaHei";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=KaiTi]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=KaiTi]::before {
        content: "楷体";
        font-family: "KaiTi";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=FangSong]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=FangSong]::before {
        content: "仿宋";
        font-family: "FangSong";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=Arial]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=Arial]::before {
        content: "Arial";
        font-family: "Arial";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=Times-New-Roman]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=Times-New-Roman]::before {
        content: "Times New Roman";
        font-family: "Times New Roman";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=sans-serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=sans-serif]::before {
        content: "sans-serif";
        font-family: "sans-serif";
    }

    .ql-font-SimSun {
        font-family: "SimSun";
    }
    .ql-font-SimHei {
        font-family: "SimHei";
    }
    .ql-font-Microsoft-YaHei {
        font-family: "Microsoft YaHei";
    }
    .ql-font-KaiTi {
        font-family: "KaiTi";
    }
    .ql-font-FangSong {
        font-family: "FangSong";
    }
    .ql-font-Arial {
        font-family: "Arial";
    }
    .ql-font-Times-New-Roman {
        font-family: "Times New Roman";
    }
    .ql-font-sans-serif {
        font-family: "sans-serif";
    }
    .ql-container{
        height: calc(100% - 42px);
    }
</style>